import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
} from "firebase/auth";
import { auth } from "./firebase";
import Alert from "@mui/material/Alert";
function Adminlogin() {
  const navigate = useNavigate();

  function handleuserlogin() {
    navigate("/");
  }

  const [admindetails, setadmindetails] = useState({
    adminmail: "",
    adminpassword: "",
  });

  const [clicked, setclicked] = useState(false);
  const [clicked2, setclicked2] = useState(false);
  const allowlogin = async (email, password) => {
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;

        window.localStorage.setItem("token", user.accessToken);

        navigate("/adminpage");
        // ...
      })
      .catch((error) => {
        const pop = {
          adminmail: "",
          adminpassword: "",
        };
        setclicked(true);
        setadmindetails((prev) => {
          return {
            ...prev,
            ...pop,
          };
        });
      });
  };

  function handleadminchange(event) {
    const { value, name } = event.target;

    setadmindetails((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  }

  async function handlelogin(event) {
    event.preventDefault();

    await allowlogin(admindetails.adminmail, admindetails.adminpassword);
  }

  async function handlereset() {
    await sendPasswordResetEmail(auth, "ankitrajput22062000@gmail.com")
      .then(() => {
        // Password reset email sent!
        // ..
        setclicked2(true);
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;

        // ..
      });
  }

  const [view, set_view] = useState("login");

  if (view === "login") {
    return (
      <div className="container mt-1">
        <div style={{ backgroundColor: "#343a40" }}>
          <nav class="navbar navbar-expand-lg navbar-dark">
            <a class="navbar-brand" href="http://nitp.ac.in/">
              <img
                src="https://nitp.ac.in/static/logo512-579d034908ae89b5e0243d1274937d5d.png"
                alt=""
                width="30"
                height="24"
                margin-right="100"
                class="d-inline-block align-text-top"
              />
              Nit Patna complaint portal
            </a>
            <button
              class="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav ml-auto">
                <li class="nav-item">
                  <button
                    className="btn btn-outline-success"
                    onClick={handleuserlogin}
                  >
                    User Login
                  </button>
                </li>
              </ul>
            </div>
          </nav>
        </div>

        <form>
          <div class="container mt-4">
            <label for="exampleInputEmail1" class="form-label">
              Email address
            </label>
            <input
              type="email"
              name="adminmail"
              class="form-control"
              id="exampleInputEmail1"
              onChange={handleadminchange}
              value={admindetails.adminmail}
              aria-describedby="emailHelp"
            />
            <label for="exampleInputPassword1" class="form-label">
              Password
            </label>
            <input
              type="password"
              name="adminpassword"
              class="form-control"
              onChange={handleadminchange}
              value={admindetails.adminpassword}
              id="exampleInputPassword1"
            />
            <br></br>
            <button class="btn btn-dark" onClick={handlelogin}>
              Submit
            </button>
            <br></br>
            <br></br>
            <button
              class="btn btn-outline-info"
              onClick={() => set_view("forgot")}
            >
              Forgot password
            </button>
          </div>
        </form>
        <div style={{ visibility: clicked ? "visible" : "hidden" }}>
          <Alert severity="error" onClose={() => setclicked(false)}>
            Incorrect Credentials!
          </Alert>
        </div>
      </div>
    );
  }
  if (view === "forgot") {
    return (
      <div className="container mt-1">
        <div style={{ backgroundColor: "#343a40" }}>
          <nav class="navbar navbar-expand-lg navbar-dark">
            <a class="navbar-brand" href="http://nitp.ac.in/">
              <img
                src="https://nitp.ac.in/static/logo512-579d034908ae89b5e0243d1274937d5d.png"
                alt=""
                width="30"
                height="24"
                margin-right="100"
                class="d-inline-block align-text-top"
              />
              Nit Patna complaint portal
            </a>
            <button
              class="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav ml-auto">
                <li class="nav-item">
                  <button
                    className="btn btn-outline-success"
                    onClick={handleuserlogin}
                  >
                    User Login
                  </button>
                </li>
              </ul>
            </div>
          </nav>
        </div>

        <div class="container mt-4">
          <button class="btn btn-dark" onClick={() => set_view("login")}>
            Login
          </button>

          <div
            class="container mt-4"
            style={{
              textAlign: "center",
            }}
          >
            <p
              style={{
                fontFamily: "Fantasy",

                padding: "20px",
              }}
            >
              A password reset link would be sent @
              ankitr*********2000@gmail.com
            </p>
            <button class="btn btn-outline-success" onClick={handlereset}>
              Get Link
            </button>
          </div>
        </div>

        <div style={{ visibility: clicked2 ? "visible" : "hidden" }}>
          <Alert severity="success" onClose={() => setclicked2(false)}>
            Reset link sent successfully!
          </Alert>
        </div>
      </div>
    );
  }
}

export default Adminlogin;
